/**
 *  订阅栏目部分的分页拆分指令，为订阅的栏目创建假分页，解决订阅栏目过多时非常卡的问题
 *  Bai.Zhiming
 *  2018-8-6
 */
"use strict";
angular.module("channelPaginationModule", []).
directive("channelPagination", ["$timeout", function($timeout) {
    return {
        restrict: "E",
        replace: true,
        transclud: false,
        templateUrl: "./networkResource/myResources/service/subscribeSource/directive/channelPagination_tpl.html",
        scope: {
            info: "=",
            searchResult: "="
        },
        link: function(scope, $element, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 8
                };
                scope.data = {};
                pageStopPropagation();
            }
            /**
             * [pageStopPropagation description] 分页阻止冒泡
             * @return {[type]} [description]
             */
            function pageStopPropagation() {
                $element.delegate('.page', 'click', function(event) { //阻止冒泡
                    event.stopPropagation();
                });
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                watcherItems();
            }
            /**
             * [getPageData description] 获取分页数据     
             * @return {[type]} [description]
             */
            function getPageData() {
                if (scope.info instanceof Array === false) return;
                scope.page.ITEMCOUNT = scope.info.length;
                scope.page.PAGECOUNT = Math.ceil(scope.info.length / scope.page.PAGESIZE);
                scope.page.CURRPAGE = scope.page.CURRPAGE > scope.page.PAGECOUNT ? scope.page.PAGECOUNT : scope.page.CURRPAGE
                var startpos = (scope.page.CURRPAGE - 1) * scope.page.PAGESIZE;
                scope.data.items = angular.copy(scope.info).splice(startpos, scope.page.PAGESIZE);
            }
            /**
             * [pageChange description] 翻页方法
             * @type {[type]}
             */
            scope.pageChange = getPageData;
            /**
             * [removeResourceFromGroup description] 从分组中直接删除资源
             * @param  {[type]} index    [description] 序号
             * @return {[type]}          [description]
             */
            scope.removeResourceFromGroup = function($event, index) {
                $event.stopPropagation();
                var startpos = (scope.page.CURRPAGE - 1) * scope.page.PAGESIZE + index;
                scope.info.splice(startpos, 1);
            };
            /**
             * [watcherItems description] 监控items的变化，并重新构建分页
             * @return {[type]} [description]
             */
            function watcherItems() {
                scope.$watch("info", function(newV, oldV) {
                    getPageData();
                }, true);
            }
        }
    };
}]);